var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top"}},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":'/img/sepia.jpg',"width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }